<template>
  <div>
    <v-select
      :items="orapSourceOptions"
      v-model="source"
      label="Källa"
      dense
      outlined
      clearable
      hide-details
    />
  </div>
</template>

<script>
import { orapSourceOptions } from '@/assets/data/options'

export default {
  name: 'FilterSourceOtherReports',
  props: {
    article_name: { type: String },
  },
  data() {
    return {
      orapSourceOptions,
    }
  },
  computed: {
    source: {
      get() {
        if (!this.article_name) return null
        return this.article_name.trim()
      },
      set(value) {
        this.$emit('change', { key: 'article_name', value })
      },
    },
  },
}
</script>

<style lang="less" scoped></style>
